const AUTH_KEY = 'authToken';
const USER_KEY = 'userData';
const EXP_KEY = 'authExpiry';

export function setSession(token, user, remember=false){
  const now = Date.now();
  const ttl = remember ? 7*24*60*60*1000 : 60*60*1000; // 7 days or 1 hour
  localStorage.setItem(AUTH_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  localStorage.setItem(EXP_KEY, String(now + ttl));
}

export function clearSession(){
  localStorage.removeItem(AUTH_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(EXP_KEY);
}

export function getUser(){
  const s = localStorage.getItem(USER_KEY);
  try { return s ? JSON.parse(s) : null } catch { return null }
}

export function getToken(){
  return localStorage.getItem(AUTH_KEY);
}

export function isSessionValid(){
  const exp = Number(localStorage.getItem(EXP_KEY) || 0);
  return Date.now() < exp && !!getToken();
}

export function ensureSessionOrLogout(onLogout){
  if(!isSessionValid()){
    clearSession();
    if (typeof onLogout === 'function') onLogout();
    return false;
  }
  return true;
} 